import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useAuth } from '@/lib/auth-store';

export function ForcePasswordChangeGuard({ children }: { children: ReactNode }) {
  const user = useAuth((s) => s.user);
  const loc = useLocation();
  if (user?.must_change_password && loc.pathname !== '/set-password') {
    return <Navigate to="/set-password" replace />;
  }
  return <>{children}</>;
}
